import { useEffect, useMemo, useState } from "react";
import api from "../../lib/api";
import { CrossStandardPicker } from "../sop/CrossStandardPicker";
import { TermCrossCheck } from "./TermCrossCheck";

// Loads the requirement catalog once and renders the shared cross-standard picker
// against ClaroLens' own presets / saved bundles (/lens/*).
export const LensScopePicker = ({ stdIds, setStdIds, selection, setSelection, focus, setFocus }) => {
  const [reqs, setReqs] = useState([]);
  const [standards, setStandards] = useState([]);
  const [scope, setScope] = useState(null);
  useEffect(() => {
    api.get("/requirements").then((r) => setReqs(r.data || [])).catch(() => {});
    api.get("/standards").then((r) => setStandards(r.data || [])).catch(() => {});
    api.get("/lens/entity-scope").then((r) => setScope(r.data)).catch(() => {});
  }, []);
  const applicableIds = useMemo(() => (scope ? new Set(scope.applicable_ids) : null), [scope]);
  return (
    <div className="space-y-2">
      {scope && (
        <div className="text-[11px] text-muted-foreground border border-border bg-secondary/30 px-2 py-1.5" data-testid="lens-entity-functions">
          Populating for your registered functions:{" "}
          <b className="text-foreground">{scope.registered_functions.length ? scope.registered_functions.join(", ") : "none set — update your Entity Profile"}</b>.
          Adding a standard auto-selects only the requirements that apply to them; presets are trimmed the same way.
        </div>
      )}
      {scope && reqs.length > 0 && setFocus && (
        <TermCrossCheck reqs={reqs} stdIds={stdIds} setStdIds={setStdIds} selection={selection} setSelection={setSelection}
          focus={focus} setFocus={setFocus} defaultFunctions={scope.registered_functions} />
      )}
      <CrossStandardPicker reqs={reqs} standards={standards} stdIds={stdIds} setStdIds={setStdIds}
        selection={selection} setSelection={setSelection} apiBase="/lens" applicableIds={applicableIds} />
    </div>
  );
};
